import { baseQuery } from '../baseQuery';

export const getDiscountReasons = async () => {
  const { data } = await baseQuery('discount-types');

  return data;
};
